import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import CountUp from 'react-countup';

import { Actions } from '../../flux';
import { images, texts } from '../../settings';
import { DelayLink, CardSlider, HoveredImage } from '../../components';

import './Pessoas.scss';
import { Link } from 'react-router-dom';

class Pessoas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,

      superintendentes_mulher: 2,
      superintendentes_homem: 3,

      gerentes_mulher: 9,
      gerentes_homem: 10,

      coordenadores_mulher: 8,
      coordenadores_homem: 12,

      analistas_mulher: 95,
      analistas_homem: 128,

      assistentes_mulher: 25,
      assistentes_homem: 18,

      apoios_mulher: 3,
      apoios_homem: 2,

      estagiarios_mulher: 10,
      estagiarios_homem: 24,

      aprendizes_mulher: 2,
      aprendizes_homem: 0,

      tempoMais20anos: 21,
      tempo16a20anos: 6,
      tempo11a15anos: 28,
      tempo6a10anos: 76,
      tempoAte5anos: 220,

      nossaIdadeIndex: 0,
    };

    this.images = images;
    this.texts = texts;

    this.nossaIdade = [
      {
        label: 'abaixo30anos',
        title: 'Abaixo de ',
        titleBold: '30 anos',
        color: 'blue',
        superintendentes: 0,
        gerentes: 0,
        coordenadores: 0,
        analistas: 52,
        assistentes: 10,
        apoios: 0,
        estagiarios: 33,
        aprendizes: 2,
        image: this.images.pessoas.pessoaAbaixo30anos,
      },
      {
        label: 'de30a50anos',
        title: 'De ',
        titleBold: '30 a 50 anos',
        color: 'yellow',
        superintendentes: 3,
        gerentes: 15,
        coordenadores: 12,
        analistas: 146,
        assistentes: 26,
        apoios: 4,
        estagiarios: 1,
        aprendizes: 0,
        image: this.images.pessoas.pessoa30a50anos,
      },
      {
        label: 'acima50anos',
        title: 'Acima de ',
        titleBold: '50 anos',
        color: 'light-blue',
        superintendentes: 2,
        gerentes: 4,
        coordenadores: 8,
        analistas: 25,
        assistentes: 7,
        apoios: 1,
        estagiarios: 0,
        aprendizes: 0,
        image: this.images.pessoas.pessoaAcima50anos,
      },
    ];

    this.contentText = React.createRef();

    this.nossaIdadePrev = this.nossaIdadePrev.bind(this);
    this.nossaIdadeNext = this.nossaIdadeNext.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  changeYearTempo(year) {
    console.log('changeYearTempo', year);
    switch (year) {
      case '2016':
        this.setState({
          tempoMais20anos: 2016,
          tempo16a20anos: 2016,
          tempo11a15anos: 2016,
          tempo6a10anos: 2016,
          tempoAte5anos: 2016,
        });
        break;

      case '2017':
        this.setState({
          tempoMais20anos: 25,
          tempo16a20anos: 7,
          tempo11a15anos: 31,
          tempo6a10anos: 85,
          tempoAte5anos: 175,
        });
        break;

      case '2018':
        this.setState({
          tempoMais20anos: 24,
          tempo16a20anos: 4,
          tempo11a15anos: 23,
          tempo6a10anos: 79,
          tempoAte5anos: 203,
        });
        break;

      case '2019':
        this.setState({
          tempoMais20anos: 21,
          tempo16a20anos: 6,
          tempo11a15anos: 28,
          tempo6a10anos: 76,
          tempoAte5anos: 220,
        });
        break;
    }
  }

  changeYearCargos(year) {
    switch (year) {
      case '2016':
        this.setState({
          superintendentes_mulher: 3,
          superintendentes_homem: 3,

          gerentes_mulher: 10,
          gerentes_homem: 10,

          coordenadores_mulher: 6,
          coordenadores_homem: 13,

          analistas_mulher: 85,
          analistas_homem: 102,

          assistentes_mulher: 18,
          assistentes_homem: 21,

          apoios_mulher: 7,
          apoios_homem: 6,

          estagiarios_mulher: 11,
          estagiarios_homem: 22,

          aprendizes_mulher: 0,
          aprendizes_homem: 0,
        });
        break;

      case '2017':
        this.setState({
          superintendentes_mulher: 2,
          superintendentes_homem: 3,

          gerentes_mulher: 10,
          gerentes_homem: 8,

          coordenadores_mulher: 6,
          coordenadores_homem: 10,

          analistas_mulher: 88,
          analistas_homem: 102,

          assistentes_mulher: 22,
          assistentes_homem: 25,

          apoios_mulher: 7,
          apoios_homem: 6,

          estagiarios_mulher: 13,
          estagiarios_homem: 19,

          aprendizes_mulher: 1,
          aprendizes_homem: 1,
        });
        break;

      case '2018':
        this.setState({
          superintendentes_mulher: 2,
          superintendentes_homem: 3,

          gerentes_mulher: 8,
          gerentes_homem: 9,

          coordenadores_mulher: 7,
          coordenadores_homem: 10,

          analistas_mulher: 88,
          analistas_homem: 121,

          assistentes_mulher: 17,
          assistentes_homem: 20,

          apoios_mulher: 6,
          apoios_homem: 5,

          estagiarios_mulher: 15,
          estagiarios_homem: 20,

          aprendizes_mulher: 1,
          aprendizes_homem: 1,
        });
        break;

      case '2019':
        this.setState({
          superintendentes_mulher: 2,
          superintendentes_homem: 3,

          gerentes_mulher: 9,
          gerentes_homem: 10,

          coordenadores_mulher: 8,
          coordenadores_homem: 12,

          analistas_mulher: 95,
          analistas_homem: 128,

          assistentes_mulher: 25,
          assistentes_homem: 18,

          apoios_mulher: 3,
          apoios_homem: 2,

          estagiarios_mulher: 10,
          estagiarios_homem: 24,

          aprendizes_mulher: 2,
          aprendizes_homem: 0,
        });
        break;
    }
  }

  nossaIdadePrev = () => {
    const { nossaIdadeIndex } = this.state;
    if (nossaIdadeIndex > 0) {
      this.setState({ nossaIdadeIndex: nossaIdadeIndex - 1 });
    } else {
      this.setState({ nossaIdadeIndex: this.nossaIdade.length - 1 });
    }
  };

  nossaIdadeNext = () => {
    const { nossaIdadeIndex } = this.state;
    if (nossaIdadeIndex < this.nossaIdade.length - 1) {
      this.setState({ nossaIdadeIndex: nossaIdadeIndex + 1 });
    } else {
      this.setState({ nossaIdadeIndex: 0 });
    }
  };

  render() {
    const totalNossaIdade =
      this.nossaIdade[this.state.nossaIdadeIndex].superintendentes +
      this.nossaIdade[this.state.nossaIdadeIndex].gerentes +
      this.nossaIdade[this.state.nossaIdadeIndex].coordenadores +
      this.nossaIdade[this.state.nossaIdadeIndex].analistas +
      this.nossaIdade[this.state.nossaIdadeIndex].assistentes +
      this.nossaIdade[this.state.nossaIdadeIndex].apoios +
      this.nossaIdade[this.state.nossaIdadeIndex].estagiarios +
      this.nossaIdade[this.state.nossaIdadeIndex].aprendizes;
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Nossas pessoas - {this.texts.title}</title>
        </Helmet>

        <div className="pessoas-home page-gradient page-gradient--blue bg-gray" ref="pessoas-home">
          <section className="pessoas-home-area pessoas-header page-gradient__header">
            <div className="container">
              <div className="row">
                <div className="col-5 col--text">
                  <Fade bottom>
                    <div className="page-header">
                      <h1 className="page-header__title gri_text gri_text--fixed">
                        Nossas pessoas
                        <span className="gri_label">
                          GRI <b> 103-1, 103-2,103-3</b>
                        </span>
                      </h1>
                      <p className="pessoas_header__text pessoas_header__text--1">Somos</p>
                      <p className="pessoas_header__text pessoas_header__text--2 high">
                        351 <small>funcionários,</small>
                      </p>
                      <p className="pessoas_header__text pessoas_header__text--3">
                        divididos em três escritórios. A maioria (59%) fica em <br className="br_desk" />
                        São Paulo, cidade que reúne todas as áreas de negócios.
                      </p>
                      <p className="pessoas_header__text pessoas_header__text--4 gri_text">
                        No Rio de Janeiro, temos a sede da Associação, com <br className="br_desk" />
                        atividades administrativas, jurídicas e de Recursos <br className="br_desk" />
                        Humanos, e o escritório do Selic, que fica no prédio <br className="br_desk" />
                        do Banco Central.
                        <span className="gri_label">
                          GRI <b>102-7, 102-8</b>
                        </span>
                      </p>
                    </div>
                  </Fade>
                </div>
                <div className="col-7 col--image">
                  <img src={this.images.pessoas.pessoas_topo1} className="pessoa1" />
                  <img src={this.images.pessoas.pessoas_topo2} className="pessoa2" />
                  <img src={this.images.pessoas.pessoas_topo3} className="pessoa3" />

                  <img src={this.images.pessoas.pessoas_topo1_mobile} className="pessoa1_mobile" />
                </div>
              </div>
            </div>
          </section>

          <section className="pessoas-body">
            <Fade bottom>
              <div className="container area-pessoas-por-escritorio">
                <div className="row">
                  <div className="col-12">
                    <div className="pessoas-body__content">
                      <h2 className="center-title">Pessoas por escritório</h2>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="pessoas-escritorio">
                      <div className="escritorio-area escritorio-area--sp">
                        <img src={images.pessoas.pessoaSP} />
                      </div>
                      <div className="escritorio-area escritorio-area--selic">
                        <img src={images.pessoas.pessoaSelic} />
                      </div>
                      <div className="escritorio-area escritorio-area--rj">
                        <img src={images.pessoas.pessoaRJ} />
                      </div>
                    </div>

                    <div className="pessoas-escritorio-legenda">
                      <div className="escritorio-area escritorio-area--sp">
                        <div className="escritorio-label">
                          <span>São Paulo</span>
                        </div>
                        <h3 className="high">208</h3>
                      </div>

                      <div className="escritorio-area escritorio-area--selic">
                        <div className="escritorio-label">
                          <span>Selic</span>
                        </div>
                        <h3 className="high">122</h3>
                      </div>

                      <div className="escritorio-area escritorio-area--rj">
                        <div className="escritorio-label">
                          <span>
                            Rio de Janeiro
                            <br />
                            <small>(Sede)</small>
                          </span>
                        </div>
                        <h3 className="high">21</h3>
                      </div>

                      <div className="escritorio-total">
                        Total <span>351</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>

            <section className="pessoas-box-pill">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <Fade bottom>
                      <div className="box-pill box-pill--green box-pill--center">
                        <div className="box-pill__content box-pill__content--full">
                          <div className="row">
                            <div className="col col-3 col--image">
                              <img src={images.pessoas.pessoa1} className="pessoa_destaque pessoa_destaque--1" />
                            </div>
                            <div className="col col-9 col--text">
                              <h4>
                                Apoiamos o Banco Central
                                <br className="br_desk" /> na operacionalização do sistema Selic
                              </h4>
                              <DelayLink
                                to="/iniciativa/selic-40-anos"
                                className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                              >
                                Saiba mais
                              </DelayLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>

            <Fade bottom>
              <div className="container area-pessoas-por-escritorio">
                <div className="row">
                  <div className="col-12">
                    <div className="pessoas-perfil">
                      <div className="row">
                        <div className="col-6 col--text">
                          <h3 className="high yellow">Perfil</h3>
                          <p className="gri_text">
                            Por aqui, buscamos igualdade de gênero:
                            <br className="br_desktop" />
                            43% da equipe interna é formada por mulheres, sendo que <br className="br_desktop" />
                            elas ficam com a mesma proporção dos cargos de chefia <br className="br_desktop" />
                            (superintendentes, gerentes e coordenadores) e metade <br className="br_desktop" />
                            dos de liderança, no <b className="yellow">Comitê Executivo</b>.
                            <span className="gri_label">
                              GRI <b>102-8, 405-1</b>
                            </span>
                          </p>
                        </div>
                        <div className="col-6">
                          <h3 className="monster yellow">
                            43
                            <img src={images.pessoas.percent} />
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>

            {/* GENERO */}
            <Fade bottom>
              <div className="container area-cargos-por-genero">
                <div className="row">
                  <div className="col-12">
                    <div className="pessoas-body__content">
                      <h2 className="left-title">Cargos por gênero</h2>
                      <p className="area-desc">
                        A maioria da equipe é formada por analistas na faixa dos 30 a 35 anos e por pessoas que estão
                        aqui há menos de cinco anos (61%). Todos os funcionários exercem jornadas de oito horas, com
                        exceção dos estagiários, que cumprem seis horas diárias, e os aprendizes, com quatro horas
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row row--second">
                  <div className="col-4 pessoa_area">
                    <img src={images.pessoas.mulher} className="pessoa pessoa-mulher" />
                    <img src={images.pessoas.symbol_mulher} className="symbol symbol-mulher" />
                  </div>

                  <div className="col-4 data_list">
                    <div className="data_list__item data_list__item--select">
                      <select
                        defaultValue="2019"
                        className="rounded_select"
                        onChange={e => this.changeYearCargos(e.target.value)}
                      >
                        {/* <option value="2016">2016</option> */}
                        <option value="2017">2017</option>
                        <option value="2018">2018</option>
                        <option value="2019">2019</option>
                      </select>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.superintendentes_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Superintendentes</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.superintendentes_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.gerentes_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Gerentes</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.gerentes_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.coordenadores_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Coordenadores</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.coordenadores_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.analistas_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Analistas</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.analistas_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.assistentes_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Assistentes</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.assistentes_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.apoios_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Pessoal de apoio</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.apoios_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.estagiarios_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Estagiários*</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.estagiarios_homem} delay={0} decimals={0} />
                      </div>
                    </div>

                    <div className="data_list__item">
                      <div className="item__number item__number--mulher">
                        <CountUp start={0} end={this.state.aprendizes_mulher} delay={0} decimals={0} />
                      </div>
                      <div className="item__text">
                        <span>Jovens aprendizes*</span>
                      </div>
                      <div className="item__number item__number--homem">
                        <CountUp start={0} end={this.state.aprendizes_homem} delay={0} decimals={0} />
                      </div>
                    </div>
                  </div>

                  <div className="col-4 pessoa_area">
                    <img src={images.pessoas.homem} className="pessoa pessoa-homem" />
                    <img src={images.pessoas.symbol_homem} className="symbol symbol-homem" />
                  </div>
                </div>
              </div>
            </Fade>
            {/* GENERO */}

            {/* TEMPO DE CASA */}
            <Fade bottom>
              <div className="container area-tempo-de-casa page-gradient--blue">
                <div className="text-area">
                  <div className="row">
                    <div className="col-8">
                      <h3>Tempo de casa</h3>
                      <p>
                        Em 2019, mais de 60% da equipe era de funcionários que entraram para a ANBIMA há menos de cinco
                        anos. Mas também temos as pratas da casa: 6% das nossas pessoas têm mais de duas décadas de
                        Associação.
                      </p>
                    </div>
                    <div className="col-3">
                      <select
                        defaultValue="2019"
                        className="rounded_select rounded_select--white"
                        onChange={e => this.changeYearTempo(e.target.value)}
                      >
                        {/* <option value="2016">2016</option> */}
                        <option value="2017">2017</option>
                        <option value="2018">2018</option>
                        <option value="2019">2019</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="mountain-area">
                  <div className="info info--mais20anos">
                    <div className="info__label">
                      Mais de
                      <br />
                      20 anos
                    </div>
                    <div className="info__value">{this.state.tempoMais20anos}</div>
                  </div>

                  <div className="info info--16a20anos">
                    <div className="info__label">
                      De 16 a<br />
                      20 anos
                    </div>
                    <div className="info__value">{this.state.tempo16a20anos}</div>
                  </div>

                  <div className="info info--11a15anos">
                    <div className="info__label">
                      De 11 a<br />
                      15 anos
                    </div>
                    <div className="info__value">{this.state.tempo11a15anos}</div>
                  </div>

                  <div className="info info--6a10anos">
                    <div className="info__label">
                      De 6 a<br />
                      10 anos
                    </div>
                    <div className="info__value">{this.state.tempo6a10anos}</div>
                  </div>

                  <div className="info info--ate5anos">
                    <div className="info__label">
                      Até
                      <br />5 anos
                    </div>
                    <div className="info__value">{this.state.tempoAte5anos}</div>
                  </div>

                  <img src={images.pessoas.mountain} className="mountain" />
                </div>
              </div>
            </Fade>
            {/* TEMPO DE CASA */}

            {/* NOSSA IDADE */}
            <Fade bottom>
              <div className="container area-nossa-idade">
                <div className="row">
                  <div className="col-7 text-column">
                    <h3 className="title">Nossa idade</h3>

                    <div
                      className={`component_nossa_idade component_nossa_idade--${
                        this.nossaIdade[this.state.nossaIdadeIndex].color
                      }`}
                    >
                      <div className="component_nossa_idade__nav">
                        <div className="c__nav__button c__nav__button--prev" onClick={this.nossaIdadePrev}></div>
                        <div className="c__nav__status">
                          {this.nossaIdade[this.state.nossaIdadeIndex].title}{' '}
                          <b>{this.nossaIdade[this.state.nossaIdadeIndex].titleBold}</b>
                        </div>
                        <div className="c__nav__button c__nav__button--next" onClick={this.nossaIdadeNext}></div>
                      </div>

                      <div className="component_nossa_idade__list">
                        <div className="component_nossa_idade__list__item">
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].superintendentes}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                          <div className="item__text">
                            <span>Superintendentes</span>
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].gerentes}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                          <div className="item__text">
                            <span>Gerentes</span>
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].coordenadores}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                          <div className="item__text">
                            <span>Coordenadores</span>
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].analistas}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                          <div className="item__text">
                            <span>Analistas</span>
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].assistentes}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                          <div className="item__text">
                            <span>Assistentes</span>
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].apoios}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                          <div className="item__text">
                            <span>Pessoal de apoio</span>
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].estagiarios}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                          <div className="item__text">
                            <span>Estagiários</span>
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item">
                          <div className="item__number item__number--mulher">
                            <CountUp
                              start={0}
                              end={this.nossaIdade[this.state.nossaIdadeIndex].aprendizes}
                              delay={0}
                              decimals={0}
                            />
                          </div>
                          <div className="item__text">
                            <span>Jovens aprendizes</span>
                          </div>
                        </div>

                        <div className="component_nossa_idade__list__item component_nossa_idade__list__item--total">
                          <div className="item__number item__number--mulher">
                            <CountUp start={0} end={totalNossaIdade} delay={0} decimals={0} />
                          </div>
                          <div className="item__text">
                            <span>Total</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-5 picture-column">
                    <img src={this.nossaIdade[this.state.nossaIdadeIndex].image} />
                  </div>
                </div>
              </div>
            </Fade>
            {/* NOSSA IDADE */}

            {/* ORGANOGRAMA */}
            <section className="organograma-box-pill">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <Fade>
                      <div className="box-pill box-pill--green box-pill--center">
                        <div className="box-pill__content box-pill__content--full">
                          <div className="row">
                            <div className="col col-3 col--image">
                              <img
                                src={images.pessoas.pessoaDestaque2}
                                className="pessoa_destaque pessoa_destaque--2"
                              />
                            </div>
                            <div className="col col-9 col--text">
                              <h4>Confira o nosso organograma</h4>
                              <DelayLink
                                to="/pessoas/organograma"
                                className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                              >
                                Saiba mais
                              </DelayLink>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </section>
            {/* ORGANOGRAMA */}
          </section>
        </div>
      </div>
    );
  }
}

export { Pessoas };
